

/**
 * Types
 */
const ASSET_PATH_TYPES = {
  'MY_COURSES': 'website-wide',
  'RECORDINGS': 'website-square',
  'WEBSITE_WIDE': 'website-wide',
  'WEBSITE_SQUARE': 'website-square',
};
/**
 *
 *
 * @class AssetsService
 */
class AssetsService {
  /**
   * Creates an instance of AssetsService.
   * @param {*} assetType
   * @memberof AssetsService
   */
  constructor(assetType) {
    this.assetType=assetType;

    this.absPath =
    `${process.env.AssetsCDN}/course-images/en`;
  }

  static DUMMY_IMG = '/images/transparent.svg';

  /**
   *
   *
   * @param {*} courseSlug
   * @return {*}
   * @memberof AssetsService
   */
  fetchAssetURL(courseSlug) {
    const assetURL =
    `${this.absPath}/${courseSlug}/${ASSET_PATH_TYPES[this.assetType]}.png`;
    return assetURL;
  }
}

export default AssetsService;
